const config = {
  TABS: {
    CONVERSATIONS: 'conversations',
    INFORMATION: 'information'
  }
}

export default config
